import { apiRequest } from "@/shared/api/client";
import type { TokenResponse } from "@/shared/api/types";

export interface LoginPayload {
  username: string;
  password: string;
  otp_password?: string;
}

/** 登录获取 access token */
export async function loginAccessToken(
  payload: LoginPayload,
): Promise<TokenResponse> {
  const form: Record<string, string> = {
    username: payload.username,
    password: payload.password,
  };
  if (payload.otp_password) {
    form.otp_password = payload.otp_password;
  }
  return apiRequest<TokenResponse>("/api/v1/login/access-token", {
    method: "POST",
    form,
    auth: false,
  });
}
